import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/sharp-solid-svg-icons'
import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import Button from '../../Button'
import styles from './ContentwithPhotoFeed.module.scss'

export default function ContentwithPhotoFeed({ fields }) {
  const {
    contentPhotoSubheading,
    choiceTextOrImageheading,
    contentPhotoheading,
    logoHeading,
    contentPhotoDescription,
    contentPhotoLinkOne,
    contentPhotoLinkTwo,
    photoFeed,
    parallaxContinuousScroll,
    headingInsideBox
  } = fields

  const [scrollPosition, setScrollPosition] = useState(0)
  const imagesContainerRef = useRef(null)

  // Derive continuous scroll state from props
  const continuousScroll = parallaxContinuousScroll === 'Continuous Scroll'

  // Check if a URL points to a PDF file
  const isPDFLink = (url) => url?.endsWith('.pdf')

  // Render the heading (text or logo)
  const renderHeading = () => {
    if (Array.isArray(choiceTextOrImageheading) && choiceTextOrImageheading.includes('Text')) {
      return <h3 className={styles.heading} dangerouslySetInnerHTML={{ __html: contentPhotoheading }}></h3>
    }
    if (logoHeading?.node?.sourceUrl) {
      return (
        <Image className={styles.logo} src={logoHeading.node.sourceUrl} alt={logoHeading.node.altText || 'Logo'} width={100} height={100} />
      )
    }
    return null
  }

  // Render the link icon based on the file type
  const renderLinkIcon = (isPDF) =>
    isPDF ? (
      <Image src="/download.svg" alt="Download PDF" width={16} height={16} style={{ marginLeft: '8px' }} />
    ) : (
      <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '8px' }} />
    )

  // Handle scrolling behavior
  useEffect(() => {
    if (continuousScroll) {
      const scrollInterval = setInterval(() => {
        setScrollPosition((prevPosition) => {
          const containerWidth = imagesContainerRef.current.scrollWidth / 2
          return prevPosition <= -containerWidth ? 0 : prevPosition - 1
        })
      }, 20)
      return () => clearInterval(scrollInterval)
    } else {
      const handleScroll = () => setScrollPosition(window.scrollY)
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  }, [continuousScroll])

  return (
    <div className={styles.teamPhotoFeed} data-aos="fade-up">
      <div className={styles.teamPhotoFeedWrapper}>
        {/* Heading Wrapper */}
        <div className={`${styles.headingWrapper} ${headingInsideBox === 'Yes' ? styles.headingWrapperHeaderInsideBox : ''}`}>
          {contentPhotoSubheading && <p className={styles.subheading}>{contentPhotoSubheading}</p>}
          {headingInsideBox === 'No' && renderHeading()}
        </div>

        {/* Main Content */}
        <div className={styles.teamPhotoFeedMainContent}>
          {/* Photo Feed */}
          <div
            className={styles.imagesContent}
            style={{
              transform: `translateX(${continuousScroll ? scrollPosition : scrollPosition * -1}px)`
            }}
            ref={imagesContainerRef}
          >
            {photoFeed.concat(photoFeed).map((photo, index) => (
              <Image
                key={index}
                className={styles.photo}
                src={photo?.photo?.node.sourceUrl}
                alt={photo?.photo?.node.altText}
                width={1000}
                height={1000}
                role="presentation"
              />
            ))}
          </div>

          {/* Content Box */}
          <div className={`${styles.WYSIWYGWrapper} ${headingInsideBox === 'Yes' ? styles.WYSIWYGWrapperHeaderInsideBox : ''}`}>
            {headingInsideBox === 'Yes' && renderHeading()}
            <div className={styles.WYSIWYG} dangerouslySetInnerHTML={{ __html: contentPhotoDescription }}></div>

            {/* Links */}
            {(contentPhotoLinkOne || contentPhotoLinkTwo) && (
              <div className={styles.linkWrapper}>
                {contentPhotoLinkOne && (
                  <Button href={contentPhotoLinkOne.url} className={styles.contentPhotoLinkOne} target={contentPhotoLinkOne.target}>
                    {contentPhotoLinkOne.title}
                    {renderLinkIcon(isPDFLink(contentPhotoLinkOne.url))}
                  </Button>
                )}
                {contentPhotoLinkTwo && (
                  <Button href={contentPhotoLinkTwo.url} className={styles.contentPhotoLinkTwo} target={contentPhotoLinkTwo.target}>
                    {contentPhotoLinkTwo.title}
                    {renderLinkIcon(isPDFLink(contentPhotoLinkTwo.url))}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
